<template>
  <el-autocomplete
      style="width:100%"
        v-model="model.lblCustomer"
        :fetch-suggestions="fetchSearchedCustomers"
        :trigger-on-focus="false"
        @select="selectCustomer"
        value="id"
        value-key="lblName"
      >
        <template slot-scope="{ item }">
          <i v-if="item.company==null" class="mdi mdi-account-circle align-vertical-middle"></i>
          <i v-else class="mdi mdi-city align-vertical-middle"></i>
          <span style="margin-left:5px; color: #8492a6; font-size: 13px">{{ item.lblName }}</span>
          <span v-if="item.overdue > 0 " style="float:right"> 
            <el-tooltip class="item" effect="dark" content="Retard de paiement" placement="top">
              <i class="el-tooltip mdi mdi-clock item" style="color:#F56C6C"></i>
            </el-tooltip>
          </span>
        </template>
    </el-autocomplete>
</template>
<script>
import customerApi from '@/services/API/customer'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'SelectCustomer',
  props: {
		customer : {
      type : Object
    },
    active : {
      type : Boolean,
      default : true
    },
    disabled: {
      type: Boolean,
      default: false
    },
	},
	data() {
		return {
      model : {
        customer : null,
        lblCustomer: "",
      },
      searchedCustomers : [],
      loading : false
	   }
   },
  computed: {
    ...mapGetters('customers',['customerName']),
  },
  components : {
  },
  methods : {
    selectCustomer(customer){
      this.$emit('selected', customer);
    },
    // fetchSearchedCustomers(queryb){
    //   this.loading = true;
    //   return customerApi.fetchSearchedCustomers({searchTerms:query,paging:'no', active:this.active})
    //   .then(searchedCustomers => {
    //     this.searchedCustomers = searchedCustomers;
    //     this.loading = false;
    //   });
    // },
    fetchSearchedCustomers(query, cb){
      this.loading = true;
      return customerApi.fetchSearchedCustomers({searchTerms:query,paging:'no', active:this.active, limit:50})
      .then(searchedCustomers => {
        this.searchedCustomers = searchedCustomers;
        this.loading = false;
        cb(_.map(searchedCustomers, c => ({
          id: c.id,
          lblName: c.company != null ? c.usual_name : c.name,
          company: c.company,
          contact: c.contact,
          rep: c.rep,
          name: c.name,
          usual_name: c.usual_name,
          overdue : c.balance_account != null ? parseFloat(c.balance_account.overdue) : 0,
        })));
      });
    },
    getCustomerByCustomerId(customerId){
      return customerApi.getCustomer(customerId)
    }
  },
  watch: {
    customer: function(newCustomer, oldCustomer) {
      if (newCustomer == null) {
        this.model.customer = null;
        this.searchedCustomers = [];
        this.model.lblCustomer = null;
      } else {
        this.searchedCustomers = [newCustomer];
        this.model.customer = newCustomer;
        this.model.lblCustomer = this.customerName(newCustomer);
      }

    }
  },
  created(){
    if(this.customer!=null){
      this.getCustomerByCustomerId(this.customer.id)
        .then(customer=>{
          this.searchedCustomers.push(customer);
          this.model.customer = customer;
          this.selectCustomer(customer)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1;
  }
}
</style>
